// Gemeinsamer Benutzer- und Rechte-Zustand für alle Bereiche (Seitenleiste, Benutzermenü, Einstiege).
// Die eigentliche Zugriffsprüfung macht der Router-Guard; hier geht es nur um die Anzeige.
import { computed, ref } from 'vue';
import axios from 'axios';
import { getApiBaseUrl } from '@/config';

const access = ref({
  username: '',
  user_role: '',
  access_modules: [],
  marketing_products: []
});
const loaded = ref(false);

function resetAccess() {
  access.value = {
    username: '',
    user_role: '',
    access_modules: [],
    marketing_products: []
  };
  loaded.value = false;
}

export function useAccess() {
  const canAccessFinancial = computed(
    () => access.value.user_role === 'admin' || access.value.access_modules.includes('financial')
  );
  const canAccessMarketing = computed(
    () => access.value.user_role === 'admin' || access.value.access_modules.includes('marketing')
  );
  const canAccessDatamanagement = computed(
    () => access.value.user_role === 'admin' || access.value.user_role === 'manager'
  );
  async function loadAccess() {
    const { data } = await axios.get(`${getApiBaseUrl()}/current_user/`, { withCredentials: true });
    access.value = {
      username: data.username || '',
      user_role: data.user_role || '',
      access_modules: Array.isArray(data.access_modules) ? data.access_modules : [],
      marketing_products: Array.isArray(data.marketing_products) ? data.marketing_products : []
    };
    loaded.value = true;
    return access.value;
  }

  return {
    access,
    loaded,
    canAccessFinancial,
    canAccessMarketing,
    canAccessDatamanagement,
    loadAccess,
    resetAccess
  };
}
